<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <sidenav-router-link icon="fa fa-home" to="/" :exact="true">Ana Sayfa</sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== 0 && kullaniciYetki !== 1" icon="fa fa-users" to="/kisi/liste"
                           :exact="true">Koordinatörler ve Hocalar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== 0 && kullaniciYetki !== 1" icon="fa fa-user" to="/ogrenci/liste"
                           :exact="true">Talebeler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== 0" icon="fas fa-book" to="/sinif/liste" :exact="true">Sınıflar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== 0 && kullaniciYetki !== 1" icon="fas fa-calendar-alt"
                           to="/baslayacak-devam-edenler"
                           :exact="true">Başlayacaklar ve Devam Edenler
      </sidenav-router-link>
      <sidenav-router-link v-if="hayratGulAtolyeMi || rehberHanimlarMi ||mekatibialiyeMi" icon="fas fa-headphones-alt"
                           to="/seminerler"
                           :exact="true">Seminerler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== 0 && !this.uluedMi" icon="fas fa-book-open" to="/eser"
                           :exact="true">Eserler
      </sidenav-router-link>
      <sidenav-router-link v-if="this.hayratGulAtolyeMi" icon="fas fa-file" to="/sertifika"
                           :exact="true">Sertifika
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== 0" icon="fas fa-hand-paper" to="/etkinlik"
                           :exact="true">Etkinlikler
      </sidenav-router-link>
      <sidenav-router-link v-if="dosyalarGozukecekMi" icon="fas fa-file" to="/dosyalar"
                           :exact="true">Dosyalar
      </sidenav-router-link>
    </div>
  </sidenav>
</template>

<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider
} from '@/vendor/libs/sidenav'
import { getRole } from '@/utils/jwtOperations'

export default {
  name: 'app-layout-sidenav',
  data () {
    return {
      kullaniciYetki: 0
    }
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    dosyalarGozukecekMi () {
      if (this.yaziAtolyesiMi) {
        return true
      }
      if (this.kullaniciYetki !== 0 && (this.mekatibialiyeMi || this.uluedMi || this.akaidOkuluMu)) {
        return true
      }

      return false
    },
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  },
  mounted () {
    this.kullaniciYetki = getRole()
  }
}
</script>
